import React, { Component } from "react";
import { Image, Header } from "semantic-ui-react";

class Presentation extends Component {
  render() {
    return (
      <div>
        <Image
          src={this.props.photoUrl}
          size="small"
          rounded
          centered
        />
        <Header as="h3" textAlign="center">
          {this.props.name}
        </Header>
      </div>
    );
  }
}

export default Presentation;



// WEBPACK FOOTER //
// ./src/scenes/ProfilPage/components/presentation.js